
$(document).ready(function(){
    var flag = 0;
    $('.external_site_link').click(function(e){
        flag = 0;
        var redirectlink = $(this).attr("data-href");
        $('.external-site-popup').fadeIn(500);
        setTimeout(function(){
            if(flag == 0){
                window.open(redirectlink);
                $('.external-site-popup').fadeOut(500);
            }
        },5000);

    });
    $('.external-popup-close').click(function(){
        flag = 1;
        $('.external-site-popup').fadeOut(500);
    }); 
});


/**
 * Helpers
 */
/**
 *  get parameter from Url
 * @param sParam
 * @returns {*}
 */
function getURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');

    for (let i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1];
        }
    }

    return false;
}

/**
 * Add parameter to Url
 * @param key
 * @param value
 */
function addParameter(key, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    if (!history.replaceState) {
        return;
    }

    window.history.replaceState({path: url.href}, '', url.href);
}

//update product based on URL param
function setCurrentProductFromUrl() {
    var productParam = getURLParameter('product');

    if (productParam) {
        $('[data-js-pm-handle="'+productParam+'"]').trigger('click');
    }
}

//update product param in URL
function setParamAfterClick(handle) {

    var handleValue = handle.data('js-pm-handle');

    if (handleValue) {
        addParameter('product', handleValue);
    }
}

$(document).ready(function () {
    // pdp with subs carousel
    $('[data-js-carousel-nav-item], [data-js-carousel-nav-item-mobile]').click(function (evt) {
        evt.preventDefault();

        $('[data-js-carousel-preview-item]').removeClass('active');
        $('[data-js-carousel-preview-item-mobile]').removeClass('active');
        $('[data-js-carousel-nav-item]').removeClass('active');
        $('[data-js-carousel-nav-item-mobile]').removeClass('active');

        $(this).addClass('active');

        $('[data-js-carousel-preview-item]').eq($(this).index()).addClass('active');
        $('[data-js-carousel-preview-item-mobile]').eq($(this).index()).addClass('active');
    });

    $('[data-js-carousel-nav]').slick({
        arrows: true,
        infinite: false,
        autoplay: false,
        variableWidth: false,
        vertical: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: '.pdp__carousel-arrow.prev',
        nextArrow: '.pdp__carousel-arrow.next'

    });

    $('[data-js-video-play]').click(function(evt) {
        evt.preventDefault();
        var mediaId = $(this).data('js-video-play');
        $('[data-js-video-lightbox="'+mediaId+'"]').css("display", "flex")
            .hide()
            .fadeIn();
    });

    $('[data-js-video-lightbox-close]').click(function(evt) {
        evt.preventDefault();
        $('[data-js-video-lightbox]').hide();
        $('[data-media-id] video').trigger('pause');
      	pauseTedVideo();
    });

    $(document).on('keyup', function(e) {
        if (e.key == "Escape") {
            $('[data-js-video-lightbox]').hide();
            $('[data-media-id] video').trigger('pause');
          	pauseTedVideo();
        }
    });
      
    // pdp products management
    var firstInit = false;
    $('[data-js-pm-item]').on('click', function(evt) {
        evt.preventDefault();

        var $form = $('.product-form-pdp-subscriptions');
        var productVariantId = $(this).attr('data-js-pm-variant-item');
        var productId = $(this).attr('data-js-pm-item');
        var productQty = $(this).attr('data-js-pm-qty');
        var productShippingType = $(this).attr('data-js-pm-frequency');
        var productPurchaseType = $(this).attr('data-js-pm-purchase-type');
        var productUnitType = $(this).attr('data-js-pm-unit-type');
        var productSellingPlan = $(this).attr('data-js-pm-selling-plan');
        var promoGallery = $(this).find('[data-product-gallery]');

        setParamAfterClick($(this));

        $('[data-js-pm-item]').removeClass('active');
        $(this).addClass('active');

        // show correct reviews
        $('[data-js-reviews-product-id]').removeClass('active');
        $('[data-js-reviews-product-id="'+ productId +'"]').addClass('active');

        // give time for loading recharge properties
        $('[data-add-to-cart]').attr('disabled','disabled');

        
        
        if (!firstInit) {
            setTimeout(function() {
                modifyId(productId, productVariantId);
                modifyUnitType($form, productUnitType);
                modifySellingPlan($form, productSellingPlan);
                modifyShippingType($form, productShippingType);
                modifyPurchaseType($form, productPurchaseType);
                if (!$('.quantity__input').length > 0) {
                  modifyQuantity($form, productQty);
                }
                $('[data-add-to-cart]').removeAttr('disabled');
                replaceGallery(promoGallery);
                firstInit = true;
            }, 2000);
        } else {
            modifyId(productId, productVariantId);
            modifyUnitType($form, productUnitType);
            modifySellingPlan($form, productSellingPlan);
            modifyShippingType($form, productShippingType);
            modifyPurchaseType($form, productPurchaseType);
            if (!$('.quantity__input').length > 0) {
              modifyQuantity($form, productQty);
            }
            replaceGallery(promoGallery);
            $('[data-add-to-cart]').removeAttr('disabled');
            firstInit = true;
        }

        var title = $(this).find('.pdp__pm-desc-title').text();
        var subTitle = $(this).find('.pdp__pm-desc-small-title').text();
        var label = $(this).find('.pdp__pm-label').text();
        var price = $(this).find('.pdp__pm-price').html();
        
        $('.fixed-product-bottomm-left .fixed-title').text(title);
        $('.fixed-product-bottomm-left .fixed-small-desc').text(subTitle);

        //Memorial Promo
        var promo_title = $(this).find('[data-promo-label-title]').text();
        var promo_price = $(this).find('[data-promo-label-price]').text();
        $('[data-bar-title]').text(promo_title);
        $('[data-bar-price]').text(promo_price);
        
        if (label != '') {
            $('.fixed-label-div').html('<p class="fixed-label">'+ label +'</p>');
            $('.fixed-label-div__mobile').html('<p class="fixed-label__mobile">'+ label +'</p>');

        } else {
            $('.fixed-label-div p').remove();
            $('.fixed-label__mobile').remove();
        }

        $('.fixed-price').html(price);

    });

    setCurrentProductFromUrl();

    $('[data-js-other-items-btn]').on('click', function(evt) {
        evt.preventDefault();
        $(this).hide();
        $('[data-js-other-items]').css("display", "flex")
            .hide()
            .slideDown();
    });


    function modifyId(productId, productVariantId) {
        if (typeof productId !== 'undefined' && productId !== false) {
            $('[data-product-form] [name="id"]').remove();
            $('[data-product-form]').append($('<input type="hidden" name="id" value="'+productVariantId+'">'));
        }
    }

    function modifyUnitType($form, productUnitType) {
        if (typeof productUnitType !== 'undefined' && productUnitType !== false) {
            $('[data-product-form] [name="properties[_shipping_interval_unit_type]"]').remove();
            $('[data-product-form]').append($('<input type="hidden" name="properties[_shipping_interval_unit_type]" value="'+productUnitType+'">'));
        } else {
            $('[data-product-form] [name="properties[_shipping_interval_unit_type]"]').remove();
        }
    }

    function modifySellingPlan($form, productSellingPlan) {
        if (typeof productSellingPlan !== 'undefined' && productSellingPlan !== false) {
            $('[data-product-form] [name="selling_plan"]').remove();
            $('[data-product-form]').append($('<input type="hidden" name="selling_plan" value="'+productSellingPlan+'">'));
        } else {
            $('[data-product-form] [name="selling_plan"]').remove();
        }
    }

    function modifyShippingType($form, productShippingType) {
        if (typeof productShippingType !== 'undefined' && productShippingType !== false) {
            $('[data-product-form] [name="properties[_shipping_interval_frequency]"]').remove();
            $('[data-product-form]').append($('<input type="hidden" name="properties[_shipping_interval_frequency]" value="'+productShippingType+'">'));
        } else {
            $('[data-product-form] [name="properties[_shipping_interval_frequency]"]').remove();
        }
    }

    function modifyQuantity($form, productQty) {
        if (typeof productQty !== 'undefined' && productQty !== false) {
            $('[data-product-form] [name="quantity"]').remove();
            $('[data-product-form]').append($('<input type="hidden" name="quantity" value="'+productQty+'">'));
        } else {
            $('[data-product-form] [name="quantity"]').remove();
        }
    }

    function replaceGallery(productGallery) {
      if (productGallery) {
        $('[data-promo-gallery]').html(productGallery.html());
        
        const slider = document.querySelector('[data-pdp-gallery-slider-mobile]');
        if (slider) {
            const prevArrow = document.querySelector('[data-pdp-gallery-slider-mobile] .h-slider__prev');
            const nextArrow = document.querySelector('[data-pdp-gallery-slider-mobile] .h-slider__next');
          
            const swiper = new Swiper(slider, {
              slidesPerView: 1.1,
              spaceBetween: 20,
              centeredSlides: false,
              grabCursor: true,
              pagination: false,
              navigation: {
                nextEl: nextArrow,
                prevEl: prevArrow,
              },
              loop: true,
            });
        }
      }
    }

    function modifyPurchaseType($form, productPurchaseType) {
        if (productPurchaseType == 'onetime') {
            $('[data-product-form] [name="properties[_shipping_interval_frequency]"]').remove();
            $('[data-product-form] [name="properties[_shipping_interval_unit_type]"]').remove();
            $('[data-product-form] [name="properties[purchase_type]"]').remove();
            $('[data-product-form] [name="selling_plan"]').remove();
        }
    }
  
  	function pauseTedVideo() {
      if($('iframe.ted-video').length) {
      	$('iframe.ted-video').attr('src', $('iframe.ted-video').attr('src'));
      }
  	}

  /* Force One time purchase option for Recharge */
  if ($('.product-single__meta').length > 0) {
    setTimeout(function(){
      $('[data-radio-onetime]').trigger('click');
    }, 5000);
    
  }
});


/*!
 * swiped-events.js - v1.1.6
 * Pure JavaScript swipe events
 * https://github.com/john-doherty/swiped-events
 * @inspiration https://stackoverflow.com/questions/16348031/disable-scrolling-when-touch-moving-certain-element
 * @author John Doherty <www.johndoherty.info>
 * @license MIT
 */
!function(t,e){"use strict";"function"!=typeof t.CustomEvent&&(t.CustomEvent=function(t,n){n=n||{bubbles:!1,cancelable:!1,detail:void 0};var a=e.createEvent("CustomEvent");return a.initCustomEvent(t,n.bubbles,n.cancelable,n.detail),a},t.CustomEvent.prototype=t.Event.prototype),e.addEventListener("touchstart",function(t){if("true"===t.target.getAttribute("data-swipe-ignore"))return;s=t.target,r=Date.now(),n=t.touches[0].clientX,a=t.touches[0].clientY,u=0,i=0},!1),e.addEventListener("touchmove",function(t){if(!n||!a)return;var e=t.touches[0].clientX,r=t.touches[0].clientY;u=n-e,i=a-r},!1),e.addEventListener("touchend",function(t){if(s!==t.target)return;var e=parseInt(l(s,"data-swipe-threshold","20"),10),o=parseInt(l(s,"data-swipe-timeout","500"),10),c=Date.now()-r,d="",p=t.changedTouches||t.touches||[];Math.abs(u)>Math.abs(i)?Math.abs(u)>e&&c<o&&(d=u>0?"swiped-left":"swiped-right"):Math.abs(i)>e&&c<o&&(d=i>0?"swiped-up":"swiped-down");if(""!==d){var b={dir:d.replace(/swiped-/,""),touchType:(p[0]||{}).touchType||"direct",xStart:parseInt(n,10),xEnd:parseInt((p[0]||{}).clientX||-1,10),yStart:parseInt(a,10),yEnd:parseInt((p[0]||{}).clientY||-1,10)};s.dispatchEvent(new CustomEvent("swiped",{bubbles:!0,cancelable:!0,detail:b})),s.dispatchEvent(new CustomEvent(d,{bubbles:!0,cancelable:!0,detail:b}))}n=null,a=null,r=null},!1);var n=null,a=null,u=null,i=null,r=null,s=null;function l(t,n,a){for(;t&&t!==e.documentElement;){var u=t.getAttribute(n);if(u)return u;t=t.parentNode}return a}}(window,document);

$(document).ready(function () {
    var mobileCarousel = document.querySelectorAll('[data-js-carousel-preview-item-mobile]');

    mobileCarousel.forEach(function(item){
        item.addEventListener('swiped-left', function(e) {
            var index = parseInt($(e.target).index());

            $('[data-js-carousel-preview-item-mobile]').removeClass('active');
            $('[data-js-carousel-nav-item-mobile]').removeClass('active');
            if (index > mobileCarousel.length - 1) {
                $('[data-js-carousel-preview-item-mobile]').eq(0).addClass('active');
                $('[data-js-carousel-nav-item-mobile]').eq(0).addClass('active');
            } else {
                $('[data-js-carousel-preview-item-mobile]').eq(index).addClass('active');
                $('[data-js-carousel-nav-item-mobile]').eq(index).addClass('active');
            }
        });

        item.addEventListener('swiped-right', function(e) {
            var index = parseInt($(e.target).index()) - 2;

            $('[data-js-carousel-preview-item-mobile]').removeClass('active');
            $('[data-js-carousel-nav-item-mobile]').removeClass('active');

            if (index < 0 ) {
                $('[data-js-carousel-preview-item-mobile]').eq(mobileCarousel.length - 1).addClass('active');
                $('[data-js-carousel-nav-item-mobile]').eq(mobileCarousel.length - 1).addClass('active');
            } else {
                $('[data-js-carousel-preview-item-mobile]').eq(index).addClass('active');
                $('[data-js-carousel-nav-item-mobile]').eq(index).addClass('active');
            }
        });
    });


    $('.pdp .stamped-product-reviews-badge').on('click', function(evt){
        evt.preventDefault();
        $([document.documentElement, document.body]).animate({
            scrollTop: $("#shopify-section-pdp-stamped-reviews").offset().top
        }, 1000);
    });
});

$(document).ready(function () {
  var videos = document.querySelectorAll('[data-js-tt-video]');
  
    videos.forEach(function(video){
      video.addEventListener('mouseenter', function(evt) {
        video.play();
      });
    });

    videos.forEach(function(video){
      video.addEventListener('click', function(evt) {
        video.muted = !video.muted;
      });
    });
    
    videos.forEach(function(video){
      video.addEventListener('mouseleave', function(evt) {
        evt.preventDefault();
        video.pause();
        video.muted = true;
      });
    });

  setTimeout(function(){
      var videos = document.querySelectorAll('.ref-out video');
    
      videos.forEach(function(video){
        video.play();
      });  
    },1000);
  

  var testimonialCarousel = document.querySelector('[data-js-testimonials-slider]');
  
  if (testimonialCarousel) {
  	$('[data-js-testimonials-slider]').slick({
        arrows: true,
        infinite: true,
        autoplay: false,
        vertical: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.testimonials__two__prev'),
        nextArrow: $('[data-js-testimonials-next]')

    });
  }

   var testimonialImagesSlider = $('[data-js-tt-slider]').slick({
        arrows: false,
        infinite: true,
        autoplay: true,
        vertical: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 3000,
        fade: true
    });

  $('[data-js-tt-slider]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    var CurrentSlideDom=$(slick.$slides.get(currentSlide + 1));
    var NextSlideDom=$(slick.$slides.get(nextSlide + 1));

    var num = CurrentSlideDom.data('js-tt-slider-el');

    $('.testimonials__slider__abs-img').removeClass('active');
    $('.abs-img-'+ num).addClass('active');
  });

  fetch(window.Shopify.routes.root + "?sections=shopify-section-testimonials-tiles")
  .then(res => res.json())
  
  
  $('[data-js-logo-slider]').slick({
        arrows: false,
        infinite: true,
        autoplay: false,
        vertical: false,
        slidesToShow: 2,
        slidesToScroll: 1
    });
  
  
  $('[data-js-home-slider]').slick({
        arrows: false,
        infinite: true,
        autoplay: true,
        vertical: false,
    	autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1
    });

  $('[data-press-reviews-slider]').slick({
        arrows: false,
        dots: true,
        customPaging : function(slider, i) {
            var thumb = $(slider.$slides[i]).data('thumb');
            return '<a><img src="'+thumb+'"></a>';
        },
        infinite: true,
        autoplay: true,
        vertical: false,
    	autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 767,
            settings: {
              dots: false
            }
        }]
    });
  
  $('[data-press-favourites-slider]').slick({
        arrows: true,
        prevArrow: '.press__slider-arrow.prev.prev-podcast',
        nextArrow: '.press__slider-arrow.next.next-podcast',
        dots: false,
        infinite: true,
        autoplay: false,
        vertical: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
        }]
    });
  
   $('[data-js-home-desktop-slider]').slick({
        arrows: true,
        infinite: true,
        autoplay: false,
        vertical: false,
        slidesToShow: 6,
        slidesToScroll: 1
    });

    $('[data-js-veterans-slider]').slick({
        arrows: false,
        infinite: true,
        autoplay: false,
        vertical: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
    });
  
 $('[data-js-minicart-slider-mobile]').slick({
                arrows: true,
                infinite: true,
                autoplay: false,
                vertical: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                swipeToSlide: true
            });
  
  $('[data-js-minicart-slider]').slick({
        arrows: false,
        infinite: true,
        autoplay: false,
        vertical: false,
        slidesToShow: 3,
        slidesToScroll: 1,
    });

  
  if(window.location.hash) {
    setTimeout(function() {
      $('html, body').animate({
          scrollTop: $(window.location.hash).offset().top -77
      }, 200 );  
    }, 1000);
  }
  
  var $sliderOne = $('[data-js-testimonials-reviews-one]').slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: 4000,
        cssEase: 'linear',
        // centerMode: true,
		slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        // infinite: true,
        arrows: false,
    	buttons: false,
    	touchMove: false,
        pauseOnHover: true
    });

  $('.tt__reviews__slider .slide-track').on('mouseenter', () => {
    $('.tt__reviews__slider .slide-track').css('animation-play-state', 'paused');
  }).on('mouseleave', () => {
    $('.tt__reviews__slider .slide-track').css('animation-play-state', 'unset');
  });
  
  var $sliderTwo = $('[data-js-testimonials-reviews-two]').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        centerMode: true,
		slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
    	buttons: false,
      	swipeToSlide: true,
    	pauseOnHover: true
    	
    });
  
  
  var loadMoreReviews = document.querySelector('[data-js-testimonials-load]');
  

    if (loadMoreReviews) {
      loadMoreReviews.addEventListener('click', function(e) {
        e.preventDefault();
        var reviews = document.querySelectorAll('.mobiles .testimonials__reviews__slide:not(.active)');
        var i = 0;
		reviews.forEach(function(review) {
          if(i < 4) {
            review.classList.add('active');
            i = i + 1;
          }
        });
        if (reviews.length < 4) {
        	loadMoreReviews.style.display = 'none';
        }
      });
    }
  
  //testimonials
  
  $('[data-js-testimonials-read-more]').on('click', function(evt) {
    evt.preventDefault();
    $(this).parent().next('.full-desc').show();
    $(this).parent().hide();
    $('.tt__reviews__slider').css('height', '460px');
  });
  
   $('[data-js-testimonials-read-less]').on('click', function(evt) {
    evt.preventDefault();
    $('.full-desc').parent().find('.short-desc').show();
    $('.full-desc').hide();
     $('.tt__reviews__slider').css('height', '320px');
  });
  
  //presspage
  
  $('[data-js-press-read-more]').on('click', function(evt) {
    evt.preventDefault();
    $(this).parent().parent().next('.full-desc').show();
    $(this).parent().parent().hide();
  });
  
   $('[data-js-press-read-less]').on('click', function(evt) {
    evt.preventDefault();
    $(this).parent().parent().find('.short-desc').show();
    $(this).parent().hide();
  });
  

  
  // var loadMorePressTiles = document.querySelector('[data-js-more-press-tiles]');
  var loadMorePressTiles = document.querySelector('[data-js-tt-more-tiles]');
  var loadMorePressTilesMobile = document.querySelector('[data-js-tt-more-tiles-mobile]');
  
  if (loadMorePressTiles) {
      loadMorePressTilesMobile.addEventListener('click', function(e) {
        e.preventDefault();
        var tiles = document.querySelectorAll('.tt__tile');
        tiles.forEach(function(tile) {
          tile.classList.add('desktop-active');
          tile.style.display = "block";
           waterfall('.tt__tiles-columns');
            
              $(window).on('resize', function(){
                waterfall('.tt__tiles-columns');
              });
          loadMorePressTilesMobile.style.display = 'none';
        });
      });
    
      loadMorePressTiles.addEventListener('click', function(e) {
        e.preventDefault();
        var tiles = document.querySelectorAll('.tt__tile:not(.desktop-active)');
        var i = 0;
		tiles.forEach(function(tile) {
          if(i < 20) {
            tile.classList.add('desktop-active');
            var waterfallContainer = document.querySelector('.tt__tiles-columns');
            if (waterfallContainer) {
              waterfall('.tt__tiles-columns');
            
              $(window).on('resize', function(){
                waterfall('.tt__tiles-columns');
              });
            }
            i = i + 1;
          }
        });
        if (tiles.length < 20) {
        	loadMorePressTiles.style.display = 'none';
        }
      });
    }
  
  // Slider for press page
  $('[data-js-press-slider]').slick({
        arrows: true,
        infinite: true,
        autoplay: false,
        vertical: false,
    	adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
  
  
  //add cookie
  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  
  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
 }
  
  if($('.main-ribbon').length) {
  	if($(window).width() < 1024) {
    	$('.page-container').css('padding-top', '67px');
    } else {
    	$('.page-container').css('padding-top', '47px');
    }
  }
  
  $('[data-js-ribbon-close]').on('click', function(evt) {
  	evt.preventDefault();
    $('.main-ribbon').slideUp();
    $('.header-website').addClass('ribbon-hidden');
    $('.page-container').css('padding-top', '0');
  });
  
  
  /** Outbrain - Tracking **/
  $('[data-add-to-cart]').on('click', function(evt) {
  	
    obApi('track', 'Add To Cart');
  });
  
  
  setTimeout(function() {
    $('[data-testid="klaviyo-form-UFwYtw"] button').on('click', function(){
      obApi('track', 'Email Signup');
      rdt('track', 'Custom', {customEventName:'Email Signup'});
    });
  }, 5000);
  
  
  // Slider for omega cells
  $('[data-js-slider-omega-cells]').slick({
    arrows: true,
        infinite: true,
        autoplay: false,
        vertical: false,
    	adaptiveHeight: false,
        slidesToShow: 1,
        slidesToScroll: 1,
    });
 
  $('[data-js-newsletters-view]').on('click', function(evt) {
    evt.preventDefault();
    var id = $(this).data('js-newsletters-view');
    var iframe =  document.querySelector('[data-js-newsletters-pdf-viewer="'+ id +'"] iframe');
    iframe.src = iframe.src; 
    
     if($(this).hasClass('active')) {
       $('[data-js-newsletters-pdf-viewer="'+ id +'"]').slideUp();
       $('[data-js-newsletters-view]').removeClass('active');
     } else {
       $('[data-js-newsletters-pdf-viewer]').slideUp();
       $('[data-js-newsletters-pdf-viewer="'+ id +'"]').slideDown();
       setTimeout(function() {
         $([document.documentElement, document.body]).animate({
              scrollTop: $('[data-js-newsletters-pdf-viewer="'+ id +'"]').offset().top - $('.header-website').height()
          }, 100);
       }, 1000);
       $('[data-js-newsletters-view]').removeClass('active');
       $(this).addClass('active');
     }
  });


  $('[data-js-newsletters-close-view]').on('click', function(evt) {
    evt.preventDefault();
       $('[data-js-newsletters-pdf-viewer]').slideUp();
       $('[data-js-newsletters-view]').removeClass('active');
  });

  /* Snow effect for holiday header */
  window.onload = function() {
			// init canvas
			var canvas = document.getElementById("snow");
            var snowWrapper = document.querySelector(".snow__top");
            if (!canvas) {
              return;
            }
			var ctx = canvas.getContext("2d");
    
			// get dimensions for canvas
			var w = snowWrapper.offsetWidth;
			var h = snowWrapper.offsetHeight;
			
			canvas.width = w;
			canvas.height = h;
			
			// snowflakes particles
			var mp = 70; // max particles
			var particles = []; // array for particles
			
			for (var i = 0; i < mp; i++) {
				particles.push({
					x : Math.random() * w, // x coord
					y : Math.random() * h, // y coord
					r : Math.random() * 5 + 1, // radius of particles
					d : Math.random() * mp, // density
				});
			}
			
			// function to draw flakes
			function draw() {
				ctx.clearRect(0,0,w,h);
				ctx.fillStyle = "rgba(255,255,255,0.8)";
				ctx.beginPath();
				
				for (var i = 0; i < mp; i++) {
					var p = particles[i];
					ctx.moveTo(p.x,p.y);
					ctx.arc(p.x,p.y,p.r,0,Math.PI * 2,true);
				}
				
				ctx.fill();
				update();
			}
			
			var angle = 0;
			
			// update snowflakes movements
			function update() {
				angle += 0.01;
				
				for (var i = 0; i < mp; i++) {
					var p = particles[i];
					// update coords x and y
					p.y += Math.cos(angle + p.d) + 1 + p.r / 2;
					p.x += Math.sin(angle) * 2;
					
					// send flakes back to the top when it exits screen
					if (p.x > w + 7 || p.x < -7 || p.y > h) {
						if (i%3 > 0) {
							// for 66% of the flakes 
							particles[i] = {x:Math.random() * w, y:-10, r : p.r, d : p.d};
						
						} else {
							// flakes exit from the right
							if (Math.sin(angle) > 0) {
								particles[i] = {x:-7, y:Math.random()*h, r:p.r, d:p.d};
							} else {
								// enter from right
								particles[i] = {x:w+7,y:Math.random()*h, r:p.r, d:p.d};
							}
						}
					}
				}
			}
			
			// animation loop every 33ms
			setInterval(draw, 33);
			
			// let's go for the demo !!!
		}
	

});  

$(document).ready(function(){

  function passcodeHcpRequest() {
   const form = document.querySelector('data-form-passcode'); 

    if (form) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const input = form.querySelector('[data-form-passcode-input]');
    
       const shopURL = '/';
       const productID = '8162986459394';
       const limit = '';
    
       const requestUrl = `products/?section_id=&product_id=${productID}`;
        
        $.ajax({
          type: 'GET',
          url: requestUrl,
          success: function (data) {
            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(data, 'text/html');
            const sectionContent = htmlDoc.querySelector('.section-hcp');
            if (sectionContent) {
              sectionContent.innerHTML = data;
            }
          }
        });
      });
    }
    passcodeHcpRequest();
  };   
  
   if(window.location.hash) {
     var hash = window.location.hash;
     setTimeout(function() {
       $([document.documentElement, document.body]).animate({
            scrollTop: $(hash).offset().top - 20
       }, 100);
     }), 2000;
  }

  //affiliate
    const closeBtnModal = document.querySelectorAll('[data-affilate-close-modal]');
    const openBtnModal = document.querySelectorAll('[data-affilate-open-modal]');
    const modalEl = document.querySelector('[data-affilate-modal]');
    
    if (modalEl) {
      openBtnModal.forEach(function(btn) {
        btn.addEventListener('click', function(event) {
          event.preventDefault();
          modalEl.classList.add('opened');
        });
      });

      closeBtnModal.forEach(function(btn) {
        btn.addEventListener('click', function(event) {
          event.preventDefault();
          modalEl.classList.remove('opened');
        });
      });
    }

    $('[data-referral-btn]').on('click', function(evt) {
      evt.preventDefault();
      window.location.hash = 'referral';
    });
    
    /*
    $('#customer_login').on('submit', function(event) {
        event.preventDefault();
      
      login('dawid.kotlarz@frompolandwithdev.com', '').done(function (html) {  
        if (html.indexOf('Invalid login credentials') !== -1) {
          // invalid password - show a message to the user
          console.log('invalid password');
        } else {
           console.log('refresh page');
        }
      });
    });
    */

  function login(email, password) {  
    var data = {
      'customer[email]': email,
      'customer[password]': password,
      form_type: 'customer_login',
      utf8: '✓'
    };
  
    var promise = $.ajax({
      url: '/account/login',
      method: 'post',
      data: data,
      dataType: 'html',
      async: true
    });
  
    return promise;
  }

  //nav heat health
  var nav = document.querySelectorAll("[data-hb-nav-icon]");

  if(nav) {
   var activeItem = document.querySelector('[data-hb-nav].active'); 
    nav.forEach(function(btn) {
      console.log(btn);
        btn.addEventListener('mouseover', function(event) {
          event.preventDefault();
          var number = btn.dataset.hbNavIcon;
          var mask = document.querySelector('[data-hb-nav="'+number+'"]');
          
          if (mask) {
            mask.classList.add('hover');
            activeItem.classList.remove('active');
          }
        }, false);
        btn.addEventListener('mouseout', function(event) {
            event.preventDefault();
            clearClassForMasks();
        }, false);
      });
  }

  function clearClassForMasks() {
    var masks = document.querySelectorAll('[data-hb-nav]');
    masks.forEach(function(mask) {
      mask.classList.remove('hover');
      activeItem.classList.add('active');
    });
  }       

  const hbTabs = document.querySelectorAll('[data-hb-tabs-tab]');
  const hbTabsContents = document.querySelectorAll('[data-hb-tabs-content]');

	hbTabs.forEach((item) => {
		item.addEventListener('click', (event)=> {
			event.preventDefault();
			const i = item.dataset.hbTabsTab;
			const hbTabsContent = document.querySelector('[data-hb-tabs-content="'+i+'"]');

			hbTabs.forEach((tab) => {
				tab.classList.remove('active');
			});
			
			hbTabsContents.forEach((tabb) => {
				tabb.classList.remove('active');
			});

			item.classList.add('active');
			hbTabsContent.classList.add('active');
		});
	});

  const scrollToReviews = document.querySelector('[data-oke-anchor]');
  const sectionReviews = document.querySelector('[data-section-reviews]');

  if (scrollToReviews) {
    scrollToReviews.addEventListener('click', (event) => {
      event.preventDefault();
      sectionReviews.scrollIntoView({ behavior: "smooth" });
    });
  }

});




  